import { render, staticRenderFns } from "./SidebarCoordination.vue?vue&type=template&id=9fec173a&scoped=true"
import script from "./SidebarCoordination.vue?vue&type=script&lang=js"
export * from "./SidebarCoordination.vue?vue&type=script&lang=js"
import style0 from "./SidebarCoordination.vue?vue&type=style&index=0&id=9fec173a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fec173a",
  null
  
)

export default component.exports